import { Box, Typography } from "@mui/material"
import { motion } from "framer-motion"
import { FitnessCenter as FitnessCenterIcon, Repeat as RepeatIcon, ViewModule as ViewModuleIcon } from "@mui/icons-material"
import axios from "axios"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import AnalyticsIcon from "@mui/icons-material/Analytics"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import isBetween from "dayjs/plugin/isBetween"
import StyledBox from "../shared/StyledBox"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)

const WorkoutStats = () => {
  const [averageWorkoutVolume, setAverageWorkoutVolume] = useState("")
  const [averageReps, setAverageReps] = useState("")
  const [averageSets, setAverageSets] = useState("")
  const { token } = useSelector((state) => state.authSlice)

  useEffect(() => {
    const fetchGenericStats = async () => {
      const result = await axios.post(
        "/api/account/genericStats",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      console.log("data", result)
      setAverageWorkoutVolume(result.data.average_workout_volume)
      setAverageReps(result.data.averageReps)
      setAverageSets(result.data.averageSets)
    }
    fetchGenericStats()
  }, [token])

  const StatCard = ({ value, label, icon }) => (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      style={{ flex: 1 }}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          borderRadius: 1,
          p: 2,
          boxShadow: 1,
          mx: 1,
        }}
      >
        <Typography
          variant="h4"
          component="div"
          sx={{
            fontWeight: "bold",
            color: "primary.main",
            mb: 0.5,
          }}
        >
          {value}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {icon}
          {label}
        </Typography>
      </Box>
    </motion.div>
  )

  return (
    <StyledBox my={1}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <AnalyticsIcon sx={{ paddingRight: "8px" }} />
          <Typography variant="h6">Workout Stats</Typography>
        </Box>
      </Box>

      <Box
        sx={{
          paddingTop: "16px",
          display: "flex",
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <StatCard
          value={averageWorkoutVolume ? `${Number.parseInt(averageWorkoutVolume).toLocaleString()} lbs` : "0"}
          label="Average weight lifted per session"
          icon={<FitnessCenterIcon fontSize="small" sx={{ mr: 1 }} />}
        />
        <StatCard
          value={averageReps || "0"}
          label="Average reps per exercise"
          icon={<RepeatIcon fontSize="small" sx={{ mr: 1 }} />}
        />
        <StatCard
          value={averageSets || "0"}
          label="Average sets per workout"
          icon={<ViewModuleIcon fontSize="small" sx={{ mr: 1 }} />}
        />
      </Box>
    </StyledBox>
  )
}

export default WorkoutStats
